import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const useClearHistoryAndNavigate = () => {
  const navigate = useNavigate();

  const clearHistory = useCallback(
    (path: string) => {
      try {
        window.history.replaceState(null, "", path);

        const clearHistoryState = () => {
          if (window.history.state !== null) {
            window.history.back();
            setTimeout(clearHistoryState, 0);
          }
        };
        clearHistoryState();

        navigate(path, {
          replace: true,
          state: { freshStart: true },
        });
      } catch (error) {
        console.error("Failed to clear history:", error);
        window.location.replace(path);
      }
    },
    [navigate]
  );

  return clearHistory;
};

export default useClearHistoryAndNavigate;
